// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"3205e24d","977":"1407b437"}[chunkId] + ".chunk.js";
};